import { render, staticRenderFns } from "./cmsCatalog.vue?vue&type=template&id=87cb5468&"
import script from "./cmsCatalog.vue?vue&type=script&lang=js&"
export * from "./cmsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports